import React from 'react'
import { BullsEyeGameSkeleton } from '../bulls-eye-game-skeleton/bulls-eye-game-skeleton'

export const BullsEyePageSkeleton: React.FC = () => {
  return <BullsEyeGameSkeleton />
}
